export default __webpack_public_path__ + "static/bitemporal-solo-v2-1fed62f7dd50232c45274dc47163423f.svg";